import CoachDetails from './CoachDetails';

export default CoachDetails;

export { type PageProps } from './types';
